// extracted by mini-css-extract-plugin
export var container = "_8u-0";
export var error = "_8u-9";
export var label = "_8u-5";
export var light = "_8u-6";
export var md = "_8u-3";
export var sm = "_8u-2";
export var thin = "_8u-8";
export var thinBold = "_8u-7";
export var vertical = "_8u-4";
export var xs = "_8u-1";